import EfSection from '@elem/ui/ef-section';
import EfSpec from '@elem/ui/ef-spec';
import EfSwiperOnlyH5 from '@elem/ui/ef-swiper-only-h5';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { t } = useLang('theProduct.SectionC');

    const listA = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724570008580/sectionC_1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724660645968/sectionC_1_h5.jpg',
            section: (
                <div className="Section-a-box">
                    <div className="Section-a">
                        <div className="Section-a-title">
                            {t.rich('a_title', {
                                t: (t) => <sup>{t}</sup>,
                            })}
                        </div>
                        <div className="Section-a-desc">{t('a_desc')}</div>
                    </div>
                    <div className="divider"></div>
                    <div className="Section-a">
                        <div className="Section-a-title">{t('b_title')}</div>
                        <div className="Section-a-desc">{t('b_desc')}</div>
                    </div>
                </div>
            ),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724570125408/sectionC_2.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724570387387/sectionC_2_h5.jpg',
            section: <></>,
        },
    ];
    return (
        <div className={styles.TheComp}>
            <EfSpec />
            <EfSection hasAnimation={false} title={t('title')} desc={t('desc')} />
            <EfSwiperOnlyH5 items={listA} />
            <EfSpec />
        </div>
    );
}
